import { render, staticRenderFns } from "./r-item-collect-mode.vue?vue&type=template&id=efc9c138"
import script from "./r-item-collect-mode.vue?vue&type=script&lang=js"
export * from "./r-item-collect-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc9c138')) {
      api.createRecord('efc9c138', component.options)
    } else {
      api.reload('efc9c138', component.options)
    }
    module.hot.accept("./r-item-collect-mode.vue?vue&type=template&id=efc9c138", function () {
      api.rerender('efc9c138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-collect-mode.vue"
export default component.exports